var _defs, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 55 55",
    style: {
      flex: "none",
      lineHeight: 1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Beam") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "beam-m"
  }, /*#__PURE__*/React.createElement("image", {
    width: 55,
    height: 55,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAA3CAAAAACNsI2aAAABkklEQVR4nLWVa27EIAyEvb3Yuifr3MzpyagSSIIHQ1ik+sdKa/z5ARN4SWSq7/13k1+RbQtDAsiSN2AByoYl6olEGhl6WL/YGHziknWme+JS0oX5/gO0tDajpk9AYK3TlD4CpQo17Y5opj5ZKVKciEc0bX2+sxNEmxvR1vjULsqKx1Jy7XOuUtLaDuBK7ulcohyp9+rJ+RH3RqPWlTH4/BYo5CiJWhZ5INeXBueMA6zUlF3E2ZN0URy0D/bwsej51wVayNkeVjq9NpkionKSy5Sp3NmMOD3lgGu4RmoBBy+a+zDG89F30Wi2w9EXrGG5hC93Vv7AReS7PGLtVU0N3AFWVWtEBdpfuJdJK4V6U/KdkTq+cljn9VVhdcdE7nF1o0UaxoMaTXgs+vKZMvUYbQ13f77UdlHHoLynkWJ9MVRJbjDcroqiQfmidUdxtwga9AI7mgEAtdwE6Qvks9nHFZSqA0pjSDPvrLRGLegsxxa+szJhushJUFIWQZk1viXnrf1eQnsFpPwMVocru5beogPuDwrwM5v4AyznAAAAAElFTkSuQmCC"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "currentColor",
    mask: "url(#beam-m)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeam);
export default __webpack_public_path__ + "static/media/beam.b50361858894829cf967531222b72c49.svg";
export { ForwardRef as ReactComponent };